<template>
  <div class="product">
    <div ref="listPannel" v-if="proItemList && proItemList.length > 0">
      <div
        class="product-item"
        v-for="item in proItemList"
        :key="item.service_id"
        @click="jumpToDetail(item.service_id)"
      >
        <h3 class="resultTip" :title="item.service_name">
          {{ item.service_name }}
        </h3>
        <ul class="key-word" v-if="item.service_keyword">
          <li
            class="key-word-item"
            v-for="(val, i) in item.service_keyword.split(',')"
            :key="i"
          >
            {{ val }}
          </li>
        </ul>
        <!-- <ul class="key-word" v-if="item.keywords.length > 0">
          <li class="key-word-item" v-for="(val, i) in item.keywords" :key="i">
            {{ val }}
          </li>
        </ul> -->
        <p :title="item.content" class="resultTip">{{ item.content }}</p>
        <div
          class="item-price"
          v-if="item.price != -1 && item.price != null && item.price != ''"
        >
          <span>￥</span>{{ item.price
          }}<span
            >/{{
              item.combo_type == 0
                ? item.invoke_times + "次"
                : item.used_length + "天"
            }}</span
          >
          <div class="service-button">查看详情</div>
        </div>
        <div
          class="item-price item-text"
          v-if="item.price == -1 || item.price == null || item.price == ''"
        >
          联系商务报价
          <div class="service-button">查看详情</div>
        </div>
        <div
          :class="
            item.service_promotion_label == 1
              ? 'is-new'
              : item.service_promotion_label == 2
              ? 'is-hot'
              : ''
          "
          v-if="item.service_promotion_label > 0"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ItemCard",
  props: ["proItemList"],
  data() {
    /**
       * service_promotion_label: 热门标签,
          price: 商品价格,
          combo_type: 1,
          invoke_times: 2,
          used_length: 3,
          content: 商品说明,
          service_keyword: 标签数组,
          service_name: 服务名称,
          service_id: 服务id，用于辨识服务，跳转页面
       */
    return {}
  },
  mounted() {
    console.log(this.proItemList)
  },
  methods: {
    jumpToDetail(id) {
      let routeData = this.$router.resolve({
        path: "/service/serviceDetail/" + id
      })
      window.open(routeData.href, "_blank")
    }
  }
}
</script>
<style lang="scss" scoped>
// .product-item {
//   > ul {
//     display: flex;
//     display: -webkit-flex;
//     flex-flow: row wrap;
//     li {
//       background: #fafcff;
//       width: 265px;
//       height: 256px;
//       padding: 15px;
//       border: 1px solid #e5e5e5;
//       margin-bottom: 30px;
//       position: relative;
//       margin-right: 10px;
//       &:nth-child(4n) {
//         margin-right: 0;
//       }
//       h3 {
//         font-weight: 700;
//         overflow: hidden;
//         white-space: nowrap;
//         text-overflow: ellipsis;
//       }

//       // .key-word {
//       //   width: 240px;
//       //   height: 21px;
//       //   margin: 12px 0 18px 0;
//       //   overflow: hidden;
//       //   span {
//       //     display: inline-block;
//       //     margin-bottom: 2px;
//       //     background: rgba(48, 140, 255, 0.11);
//       //     border-radius: 11px;
//       //     margin-right: 8px;
//       //     font-size: 12px;
//       //     color: #3060ff;
//       //     line-height: 12px;
//       //     padding: 4px 9px;
//       //   }
//       // }
//       .key-word {
//         width: 100%;
//         height: 20px;
//         overflow: hidden;
//         margin-bottom: 18px;
//         .key-word-item {
//           float: left;
//           font-size: 12px;
//           color: #3060ff;
//           letter-spacing: 0.5px;
//           height: 20px;
//           line-height: 20px;
//           max-width: 220px;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           white-space: nowrap;
//           background: rgba(48, 140, 255, 0.11);
//           border-radius: 11px;
//           padding: 0 9px;
//           margin-right: 8px;
//         }
//       }
//       p {
//         color: #6d8195;
//         line-height: 22px;
//         overflow: hidden;
//         text-overflow: ellipsis;
//         display: -webkit-box;
//         -webkit-line-clamp: 5;
//         -webkit-box-orient: vertical;
//         word-break: break-all;
//         cursor: pointer;
//       }
//       .item-price {
//         position: absolute;
//         bottom: 0;
//         left: 0;
//         color: #ff595e;
//         font-size: 24px;
//         font-weight: 700;
//         height: 45px;
//         width: 260px;
//         line-height: 45px;
//         padding-left: 15px;
//         overflow: hidden;
//         // width: 208px;
//         // height: 28px;
//         // line-height: 28px;
//         // border-radius: 2px;
//         // background: #ffffff;
//         // border: 1px solid #dddddd;
//         // // margin-bottom: 24px;
//         // font-size: 12px;
//         // text-align: center;
//         span {
//           font-size: 14px;
//           font-weight: normal;
//           &:nth-child(2) {
//             color: #999999;
//           }
//         }
//       }
//       .item-text {
//         font-size: 20px;
//       }
//       .service-button {
//         position: absolute;
//         bottom: -45px;
//         left: 0;
//         width: 100%;
//         height: 45px;
//         line-height: 45px;
//         background-image: linear-gradient(209deg, #0037ff 0%, #4774fe 100%);
//         font-size: 16px;
//         color: #ffffff;
//         letter-spacing: 0;
//         text-align: center;
//         z-index: -1;
//         transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
//         font-weight: normal;
//       }
//       .is-new {
//         position: absolute;
//         top: -6px;
//         right: -12px;
//         background: url("../assets/service/new.png") no-repeat;
//         width: 74px;
//         height: 74px;
//       }
//       .is-hot {
//         position: absolute;
//         top: -6px;
//         right: -12px;
//         background: url("../assets/service/hot.png") no-repeat;
//         width: 74px;
//         height: 74px;
//       }
//       &:hover {
//         cursor: pointer;
//         box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.11);
//         .service-button {
//           bottom: 0;
//           z-index: 1;
//         }
//       }
//     }
//   }
// }
.product {
  .product-item {
    position: relative;
    width: 260px;
    height: 260px;
    padding: 15px;
    background: #fff;
    display: inline-block;
    margin: 0 8px 40px 0;
    vertical-align: middle;
    word-break: break-all;
    border: 1px solid #e5e5e5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    &:hover {
      cursor: pointer;
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.11);
      .service-button {
        bottom: 0;
        z-index: 1;
      }
    }
  }
  h3 {
    font-weight: 700;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .key-word {
    width: 100%;
    height: 20px;
    overflow: hidden;
    margin-bottom: 18px;
    .key-word-item {
      float: left;
      font-size: 12px;
      color: #3060ff;
      letter-spacing: 0.5px;
      height: 20px;
      line-height: 20px;
      max-width: 220px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      background: rgba(48, 140, 255, 0.11);
      border-radius: 11px;
      padding: 0 9px;
      margin-right: 8px;
    }
  }
  p {
    color: #6d8195;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    word-break: break-all;
    cursor: pointer;
  }
  .item-price {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #ff595e;
    font-size: 24px;
    font-weight: 700;
    height: 45px;
    width: 260px;
    line-height: 45px;
    padding-left: 15px;
    overflow: hidden;
    // width: 208px;
    // height: 28px;
    // line-height: 28px;
    // border-radius: 2px;
    // background: #ffffff;
    // border: 1px solid #dddddd;
    // // margin-bottom: 24px;
    // font-size: 12px;
    // text-align: center;
    span {
      font-size: 14px;
      font-weight: normal;
      &:nth-child(2) {
        color: #999999;
      }
    }
  }
  .item-text {
    font-size: 20px;
  }
  .service-button {
    position: absolute;
    bottom: -45px;
    left: 0;
    width: 100%;
    height: 45px;
    line-height: 45px;
    background-image: linear-gradient(209deg, #0037ff 0%, #4774fe 100%);
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    z-index: -1;
    transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
    font-weight: normal;
  }
  .is-new {
    position: absolute;
    top: -6px;
    right: -12px;
    background: url("../assets/service/new.png") no-repeat;
    width: 74px;
    height: 74px;
  }
  .is-hot {
    position: absolute;
    top: -6px;
    right: -12px;
    background: url("../assets/service/hot.png") no-repeat;
    width: 74px;
    height: 74px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/components/ItemCard.vue